module.exports = __webpack_public_path__ + "img/gb-wls.182b1b61.svg";